import { convertEnumToComponentItem } from "csi/middleware/common";
import { ICustomViewUtil } from "csi/middleware/customView/customViewService";
import { ICustomViewImageFormatOptions } from "csi/middleware/customView/options/CustomViewOptions";
import reflection from "csi/reflection";
import { ILocaleProvider } from "designSystem/locale";
import { ComponentItem } from "designSystem/types/component-item-types";
import { action, computed, makeObservable, observable } from "mobx";
import { ChangeEvent } from "react";

export default class CustomViewImageFormatStore implements ICustomViewUtil<ICustomViewImageFormatOptions>{
	/** image export format */
	@observable imageExportFormat?: string;

	/** image format data */
	readonly data: ComponentItem[] = [];

	readonly loc: ILocaleProvider;

	@computed get optionValues(): ICustomViewImageFormatOptions {
		return { imageExportFormat: this.imageExportFormat };
	}

	@computed get selectedImageExportFormat(): ComponentItem {
		return this.data.find((item) => item.id === this.imageExportFormat);
	};

	@action setImageExportFormat = (event: ChangeEvent<{}>, value: ComponentItem): void => {
		this.imageExportFormat = value.id;
	};

	/** @override react on custom view selection */
	@action onChangeOptions = (options: ICustomViewImageFormatOptions): void => {
		this.imageExportFormat = options.imageExportFormat || reflection.IMAGE_EXPORT_FORMAT_IMAGEID_IMAGE_NODENAME_JPG;
	};

	constructor(options: ICustomViewImageFormatOptions, loc: ILocaleProvider) {
		makeObservable(this);
		this.loc = loc;
		this.data = convertEnumToComponentItem(reflection.IMAGE_EXPORT_FORMAT);
		this.onChangeOptions(options);
	}
}